<template>
    <span style="line-height: 22px; text-align: justify">
        <span v-if="showMore">
            {{words.slice(0, len).join(' ')}}
        </span>
        <span v-else>
            {{text}} <span style="opacity: 0">.</span>
        </span>
        <a-space v-if="showIcon">
            <a @click="handleChange" style="margin-left: 5px">
                <DownCircleOutlined v-if="showMore"/>
                <UpCircleOutlined v-else/>
            </a>
        </a-space>

    </span>
</template>

<script>
    import {DownCircleOutlined, UpCircleOutlined} from '@ant-design/icons-vue';

    export default {
        name: "MoreORLess",
        components: {
            DownCircleOutlined, UpCircleOutlined
        },
        props: ['len', 'noTip', 'text'],
        data(){
            let {text, len} = this;
            text = text || '';
            let words = text.split(' ');
            return {
                words,
                showIcon: words.length > len,
                showMore: true,
                tipText: 'Show more',
            }
        },
        watch: {
            text: function(newValue, oldValue){
                if(newValue !== oldValue){
                    console.log(newValue, oldValue);
                    this.words = newValue.split(' ');
                }
            }
        },
        methods: {

            handleChange(){
                let {showMore} = this;
                this.showMore = !showMore;
                this.tipText = showMore? ('Show more'): ('Show less');
            }
        }
    }
</script>

<style scoped>

</style>
